import _ from 'lodash';
import Cookies from 'universal-cookie';

import * as consts from '../constants';
import * as commonActions from './commonActions';

// import authenticationApi from '../api/mocks/mockAuthenticationApi'
import authenticationApi from '../api/authenticationApi';

const cookies = new Cookies();

export function loginSuccess(authenticationState) {
    // Store or Cookie
    if (typeof (Storage) !== 'undefined')
        localStorage.setItem(consts.AUTHENTICATION.STORAGE_NAME, JSON.stringify(authenticationState));
    else
        cookies.set(consts.AUTHENTICATION.COOKIE_NAME, authenticationState, { path: '/' });

    return { type: consts.ACTONS.LOGIN_SUCCESS, authenticationState };
}

export function logOutSuccess() {
    // Store or Cookie
    if (typeof (Storage) !== 'undefined')
        localStorage.setItem(consts.AUTHENTICATION.STORAGE_NAME, null);
    else
        cookies.remove(consts.AUTHENTICATION.STORAGE_NAME, { path: '/' });

    return { type: consts.ACTONS.LOGOUT_SUCCESS };
}

export function loginWithToken(sanityToken) {
    return async function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        try {
            const authenticationState = await authenticationApi.loginWithToken(sanityToken);
            dispatch(loginSuccess(authenticationState));
            dispatch(commonActions.unlockScreen());
            dispatch(commonActions.loadConfiguration());
        }
        catch (error) {
            dispatch(commonActions.unlockScreen());
            throw (error);
        }
    };
}

export function loginSso(isakToken) {
    return async function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        try {
            const authenticationState = await authenticationApi.loginSso(isakToken);
            dispatch(loginSuccess(authenticationState));
            dispatch(commonActions.unlockScreen());
            dispatch(commonActions.loadConfiguration());
        }
        catch (error) {
            dispatch(commonActions.unlockScreen());
            throw (error);
        }
    };
}

export function login(loginModel) {
    return async function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        try {
            const authenticationState = await authenticationApi.login(loginModel);
            dispatch(loginSuccess(authenticationState));
            dispatch(commonActions.unlockScreen());
            dispatch(commonActions.loadConfiguration());
        }
        catch (error) {
            dispatch(commonActions.unlockScreen());
            throw (error);
        }
    };
}

export function logout() {
    return async function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        try {
            await authenticationApi.logout(getState().authenticationState.token);
            dispatch(logOutSuccess());
            dispatch(commonActions.unlockScreen());
        }
        catch (error) {
            dispatch(commonActions.unlockScreen());
            throw (error);
        }
    };
}

export function generateResetLink(model) {
    return async function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        try {
            await authenticationApi.generateResetLink(model);
            dispatch(commonActions.unlockScreen());
        }
        catch (error) {
            dispatch(commonActions.unlockScreen());
            throw (error);
        }
    };
}

export function resetPassword(model) {
    return async function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        try {
            await authenticationApi.resetPassword(model);
            dispatch(commonActions.unlockScreen());
        }
        catch (error) {
            dispatch(commonActions.unlockScreen());
            throw (error);
        }
    };
}

export function verifyAuthentication(authenticationState, history) {
    if (!authenticationState || !authenticationState.token || authenticationState.token === '') {
        history.push('/login');
        return false;
    }
    return true;
}

export function lookForCookie() {
    var authenticationState = undefined;

    try {
        // Store or Cookie
        if (typeof (Storage) !== 'undefined')
            authenticationState = JSON.parse(localStorage.getItem(consts.AUTHENTICATION.STORAGE_NAME));
        else
            authenticationState = cookies.get(consts.AUTHENTICATION.STORAGE_NAME);
    } catch (err) {
        // This cos we can have a bad value in storage.
    }

    return { type: consts.ACTONS.INIT_APP, authenticationState };
}

export function alreadyLoggedIn(history) {
    var authenticationState = undefined;

    try {
        // Store or Cookie
        if (typeof (Storage) !== 'undefined')
            authenticationState = JSON.parse(localStorage.getItem(consts.AUTHENTICATION.STORAGE_NAME));
        else
            authenticationState = cookies.get(consts.AUTHENTICATION.STORAGE_NAME);
    } catch (err) {
        // This cos we can have a bad value in storage.
    }

    if (authenticationState && authenticationState.token)
        history.push('/');
}

export function isAdmin(authenticationState) {
    return authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.Admin;
}

export function canISeeQuotationPage(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canIEditTariff(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canISeeSociSostenitori(authenticationState) {
    return authenticationState.roleId < consts.AUTHENTICATION.USER_ROLE.NetworkOwner || authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.NetworkReferent || authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.NetworkMaster;
}

export function canISeeNetworkProductTariff(authenticationState) {
    return authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && authenticationState.roleId !== consts.AUTHENTICATION.USER_ROLE.NetworkMaster;
}

export function canISeeAmministrazione(authenticationState) {
    return authenticationState.roleId !== consts.AUTHENTICATION.USER_ROLE.CentraleOperativa && authenticationState.roleId !== consts.AUTHENTICATION.USER_ROLE.NetworkMaster;
}

export function canIAddNetwork(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canIEditNetwork(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.NetworkOwner;
}

export function canISeeQuotes(authenticationState, network) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb && network.id > 0;
}

export function canISeeNetworkDocuments(authenticationState, network) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb && network.id > 0;
}

export function canISeeNetworkNotes(authenticationState, network) {
    return network.id > 0 && (authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb ||
        authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.NetworkReferent);
}

export function canISeeNetworkMasters(authenticationState, network) {
    return network.id > 0 && (authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb);
}

export function canISeeNetworkPianoFlexSection(authenticationState, network) {
    return network.id > 0 && (authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb);
}

export function canISeeUserDocuments(authenticationState, user) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb && user.id > 0;
}

export function canIEditAgenti(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.NetworkOwner;
}

export function canIAddProduct(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canIDeleteProduct(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canICloneProducts(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canICloneWarranty(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canICloneTariff(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canISeeReports(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canIManageTariffGroups(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canIManageUsers(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canIAddUser(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.NetworkOwner;
}

export function canICreateAdesione(authenticationState) {
    return authenticationState.roleId !== consts.AUTHENTICATION.USER_ROLE.NetworkReferent &&
        authenticationState.roleId !== consts.AUTHENTICATION.USER_ROLE.NetworkMaster &&
        authenticationState.roleId !== consts.AUTHENTICATION.USER_ROLE.CentraleOperativa;
}

export function canIManageCompanies(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canISeeWarrantiesQuotations(authenticationState) {
    return authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canIUploadDocumentiPersonali(authenticationState, contract) {
    return authenticationState.roleId !== consts.AUTHENTICATION.USER_ROLE.NetworkMaster;
}

export function canIUpdateDatiPreventivo(authenticationState, contract) {
    if (contract.status > consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA)
        return false;

    return (authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.Seb ||
        (
            authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.NetworkAgent &&
            contract.status === consts.GENERIC_ENUM.CONTRACT_STATUS.PREVENTIVO &&
            contract.accountPeriodEMIStatus === consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.PAGAMENTO
        )
    );
}

export function canIViewNoteAgguntive(authenticationState, contract) {
    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Admin)
        return false;

    return authenticationState.network.extraNoteEnabled;
}

export function canIViewNoteNonStampate(authenticationState, contract) {
    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.CentraleOperativa)
        return false;

    return authenticationState.network.extraNoteEnabled;
}

export function canIUpdateNoteNonStampate(authenticationState, contract) {
    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.NetworkAgent)
        return false;

    return authenticationState.network.extraNoteEnabled;
}

export function canIUpdateNoteAgguntive(authenticationState, contract) {
    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.NetworkAgent)
        return false;

    if (contract.status > consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA)
        return false;

    return authenticationState.network.extraNoteEnabled;
}

export function canIAddContractMember(authenticationState, contract, employee) {
    if (contract.isPianoFlex || authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.NetworkMaster)
        return false;

    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb)
        return contract.status < consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && (_.isNil(employee) || _.isNil(employee.fineCopertura));

    return contract.status <= consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && (_.isNil(employee) || _.isNil(employee.fineCopertura));
}

export function pianoFlexCanIAddContractMember(authenticationState, contract, employee) {
    if (!contract.isPianoFlex)
        return false;

    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb)
        return contract.status < consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && (_.isNil(employee) || _.isNil(employee.fineCopertura));

    return contract.status <= consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && (_.isNil(employee) || _.isNil(employee.fineCopertura));
}

export function canIDeleteContractMember(authenticationState, contract, member) {
    if (contract.isPianoFlex)
        return false;

    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb)
        return contract.status < consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && _.isNil(member.fineCopertura);

    return contract.status <= consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && _.isNil(member.fineCopertura);
}

export function pianoFlexCanIDeleteContractMember(authenticationState, contract, member) {
    if (!contract.isPianoFlex)
        return false;

    if (authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb)
        return contract.status < consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && _.isNil(member.fineCopertura);

    return contract.status <= consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && _.isNil(member.fineCopertura);
}

export function canIRenewals(authenticationState, contract) {
    if (contract.isPianoFlex)
        return false;

    // All accountPeriod are paid and status is polizza and role i seb or above
    for (var i = 0; i < contract.accountperiods.length; i++) {
        if (contract.accountperiods[i].status === consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.ESITO_PAGAMENTO_KO || contract.accountperiods[i].status === consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.PAGAMENTO)
            return false;
    }
    return contract.status === consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function pianoFlexCanIRenewals(authenticationState, contract) {
    if (!contract.isPianoFlex || authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.NetworkMaster)
        return false;

    // All accountPeriod are paid and status is polizza and role i seb or above
    for (var i = 0; i < contract.accountperiods.length; i++) {
        if (contract.accountperiods[i].status === consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.ESITO_PAGAMENTO_KO || contract.accountperiods[i].status === consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.PAGAMENTO)
            return false;
    }
    return contract.status === consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function canICancelRenewals(authenticationState, contract) {
    if (authenticationState.roleId === consts.AUTHENTICATION.USER_ROLE.NetworkMaster)
        return false;

    // Ci deve essere un rinnovo in atto.
    var renewAP = contract.accountperiods.filter(x => x.accountActivityId === consts.GENERIC_ENUM.ACCOUNT_PERIOD_ACTIVITY.RINNOVO &&
        x.status === consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.PAGAMENTO)[0];
    if (_.isNil(renewAP))
        return false;

    return contract.status === consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA && authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb;
}

export function closeContractEnabled(authenticationState, contract) {
    return (authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb &&
        contract.status === consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA);
}

export function canIDeleteDocument(authenticationState, contract) {
    return (authenticationState.roleId <= consts.AUTHENTICATION.USER_ROLE.Seb);
}
